export const META_ADD = 'META_ADD';

export const META_REDUCER_NAME = 'meta';
